import { StyleSheet } from 'react-native';

export default function resolveStyle(styles) {
  if (Array.isArray(styles)) {
    return styles.map(resolveStyle);
  }

  if (typeof styles === 'number') {
    return StyleSheet.flatten(styles);
  }

  return styles;
}
